import {
  PublicDataRequestStart,
  PublicDataRequestVerify,
  PublicFormSubmit,
  PublicDataRequestStarted,
  PublicDataRequestStatus,
  PublicDataRequestVerified,
  PublicFormSubmitResult,
  PublicFormView,
  PublicPrivacyPage,
} from '@cloudsign/shared';
import type { z } from 'zod';
import { api } from '../../lib/api';

/**
 * API calls of the public pages added in Phase 4 (pre-registration forms, privacy page and data requests). No session;
 * a 401 never sends the visitor to the portal sign-in (quiet401). Tokens and slugs always travel in the path.
 */
const enc = encodeURIComponent;

export type FormSubmit = z.input<typeof PublicFormSubmit>;
export type RequestStart = z.input<typeof PublicDataRequestStart>;
export type RequestVerify = z.input<typeof PublicDataRequestVerify>;
export type RequestStarted = z.infer<typeof PublicDataRequestStarted>;
export type RequestVerified = z.infer<typeof PublicDataRequestVerified>;
export type RequestStatus = z.infer<typeof PublicDataRequestStatus>;

export const FORM_URL = (tenantSlug: string, slug: string) => `/pre-registration/public/forms/${enc(tenantSlug)}/${enc(slug)}`;
export const DP = '/data-protection/public';
/** Where the browser downloads a data export (the server answers 302 to the ZIP). */
export const exportUrl = (token: string) => `/api/v1${DP}/exports/${enc(token)}`;

export const getForm = (tenantSlug: string, slug: string) => api.get(FORM_URL(tenantSlug, slug), { schema: PublicFormView, quiet401: true });
export const submitForm = (tenantSlug: string, slug: string, body: FormSubmit) =>
  api.post(FORM_URL(tenantSlug, slug), { body, schema: PublicFormSubmitResult, quiet401: true });

export const getPrivacy = (tenantSlug: string) => api.get(`${DP}/${enc(tenantSlug)}/privacy`, { schema: PublicPrivacyPage, quiet401: true });
export const startRequest = (tenantSlug: string, body: RequestStart) =>
  api.post(`${DP}/${enc(tenantSlug)}/requests`, { body, schema: PublicDataRequestStarted, quiet401: true });
export const verifyRequest = (tenantSlug: string, body: RequestVerify) =>
  api.post(`${DP}/${enc(tenantSlug)}/requests/verify`, { body, schema: PublicDataRequestVerified, quiet401: true });
export const getRequestStatus = (token: string) => api.get(`${DP}/requests/${enc(token)}`, { schema: PublicDataRequestStatus, quiet401: true });
